import CustomView from "../../custom-view/custom-view"
import navigation_addSection from "./add-section"
import {ViewType} from "../../../gd/const/views/view-type"
import {NavigationButtonPosition} from "../@const"
import navigation_replaceSection from "./replace-section"
import NavigationSection from "../navigation-section";
import { BUS_NAVIGATION_CHANGED } from "../../../../layout/navigation/@const"

const debug = false
// const debug = "navigation_addCustomViewToNavigation"

export default function navigation_addCustomViewToNavigation(customView:CustomView, position:NavigationButtonPosition) {

    debug && console.log(debug, 'process', customView)

    const navigationStructure = gd.navigationStructure

    // Super important - because this view changes location make sure it no set as default view for any of the sections
    navigationStructure.removeViewFromDefaultSectionsPage(customView)


    const section : NavigationSection = customView.toNavigationSection()
    section.position = position
    gd.navigationStructure.savePositions()
    gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED) // navigation settings app rerender

    // remove if already present
    navigationStructure.remove(section.id)

    switch (customView.type) {

        // case ViewType.MY_TIME   :
        // case ViewType.MY_GOALS  :
        //     navigation_addSection(section, 1,false)
        //     break

        case ViewType.MY_ATTENDANCE:
            const foundSection = navigationStructure.getByCustomViewType(ViewType.MY_ATTENDANCE)
            // found section should be replaced
            // otherwise just add as any other custom view
            if (foundSection)   navigation_replaceSection(foundSection, section)
            else                navigation_addSection(section, 3,false)
            break

        default:
            navigation_addSection(section, 3,false)
            break
    }


}
